module.exports = __webpack_public_path__ + "static/media/img-axum-quote@2x.04cf4f23.png";